import client from "../libs/HttpClient";
class FeaturesService {
  static getFeaturesData() {
    return client.get("/features-list");
  }
  
}
export { FeaturesService };
